<template>
  <div class="wrapper-full" style="position: absolute; top: 0px">
    <div class="header-container border-bottom-thin">
      <el-row type="flex" class="oprators" align="bottom">
        <el-col :span="12" align="center">
          <el-button class="btn-oprator border-normal" @click="save">
            <span class="label iconfont icon-save"></span>&nbsp;&nbsp;
            <span class="label">{{ $t("langcfg.txtSave") }}</span>
          </el-button>
        </el-col>
        <el-col :span="12" :offset="1" align="center">
          <el-button class="btn-oprator border-normal" @click="cancel">
            <span class="label iconfont icon-cancel-1"></span>&nbsp;&nbsp;
            <span class="label">{{ $t("langcfg.txtCancel") }}</span>
          </el-button>
        </el-col>
      </el-row>

      <div class="patient-info-cotainer" :dispW="tableWith" :dispH="tableHeight">
        <el-row
          v-for="(item, key) in patientInfo"
          :key="key"
          :class="`${language}_${key}`"
          :style="`margin-top: 40px;${isZHCN && key === 'lastname' ? 'display:none' : ''}`"
        >
          <el-col :span="6" style="text-align: center; line-height: 50px">
            <label class="input-label">{{ $t(`langcfg.${item.title}`) }}:</label>
          </el-col>
          <el-col :span="16">
            <template v-if="item.focused">
              <el-input
                :class="`input ${fnClass}`"
                v-model.lazy="item.value"
                v-focus
                @focus="cancelTip('firstname')"
                data-value="firstname"
              ></el-input>
            </template>
            <template v-else-if="key === 'pid'">
              <el-input
                :class="`input ${pidClass}`"
                v-model="item.value"
                @focus="cancelTip('pid')"
                @click.native.prevent.stop="handleClick(key)"
                @touchend.native.stop.prevent="handleClick(key)"
              ></el-input>
            </template>
            <template v-else-if="key === 'firstname'">
              <el-input
                class="input"
                v-model="item.value"
                @click.native.stop.prevent="handleClick(key)"
                @touchend.native.stop.prevent="handleClick(key)"
              ></el-input>
            </template>
            <template v-else-if="key === 'lastname'">
              <el-input
                class="input"
                v-model="item.value"
                @click.native.stop.prevent="handleClick(key)"
                @touchend.native.stop.prevent="handleClick(key)"
              ></el-input>
            </template>
            <template v-else-if="key === 'address'">
              <el-input
                class="input"
                v-model="item.value"
                @click.native.stop.prevent="handleClick(key)"
                @touchend.native.stop.prevent="handleClick(key)"
              ></el-input>
            </template>
            <template v-else-if="key === 'phone'">
              <el-input
                class="input"
                v-model="item.value"
                @click.native.stop.prevent="handleClick(key)"
                @touchend.native.stop.prevent="handleClick(key)"
              ></el-input>
            </template>
            <template v-else-if="key === 'email'">
              <el-input
                class="input"
                v-model="item.value"
                @click.native.stop.prevent="handleClick(key)"
                @touchend.native.stop.prevent="handleClick(key)"
              ></el-input>
            </template>
            <template v-else-if="item.type === 'SELECT'">
              <div style="width: 100%">
                <el-radio-group v-model="item.value" size="mini">
                  <el-radio label="M" border>{{ $t("langcfg.txtMale") }}</el-radio>
                  <el-radio label="F" border>{{ $t("langcfg.txtFemale") }}</el-radio>
                  <el-radio label="O" border>{{ $t("langcfg.txtSexOther") }}</el-radio>
                  <el-radio label="U" border>{{ $t("langcfg.txtSexUnknown") }}</el-radio>
                </el-radio-group>
              </div>
            </template>
            <template v-else>
              <el-date-picker
                style="width: 100%"
                :format="dateFmt"
                value-format="yyyy-MM-dd"
                v-model="item.value"
                type="date"
                placeholder
              ></el-date-picker>
            </template>
          </el-col>
          <el-col :span="1">
            <label class="input-label input-need" v-if="item.required">*</label>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { initPatientCfg } from "../../services/patient";
import { objectCopy, isDefined, testSpecialChar } from "../../shared/utils";
import { Message, Size } from "../../mixins";
import { SPECIALKEYS } from "../../shared/consts";
import EVENTS from "../../bus";
import Radio from "../../common/components/Radio.vue";
import fileSys from "../../fileoprators/fileSystem";
export default {
  name: "PatientEdit",
  data() {
    return {
      patientInfo: {},
      dateFmt: "yyyy/MM/dd",
      invalidKey: "none",
      dialogVisible: false,
      iframeUrl: "",
      firstnameInput: "",
      addressInput: "",
      phoneInput: "",
      emailInput: "",
      pidInput: "",
      gender: "M",
      genders: [
        { key: "male", checked: true, label: "txtMale", value: "M" },
        { key: "famale", checked: false, label: "txtFemale", value: "F" }
      ],
      isZHCN: false
    };
  },
  created() {
    this.initEdit();
    this.isZHCN = window.settings.language === "zh_CN";
  },
  mixins: [Size, Message],
  props: {
    language: {
      type: String,
      default: ""
    },
    patient: {
      type: Object
    },
    addOrEdit: {
      type: String,
      default: "add"
    }
  },
  components: {
    Radio
  },
  watch: {
    language: function () {
      this.isZHCN = window.settings.language === "zh_CN";
      this.initEdit();
    },
    patient: {
      handler(newVALUE) {
        // console.log('监听中的patient', newVALUE)
      },
      deep: true,
      immediate: true
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").focus();
      }
    }
  },
  methods: {
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.patientInfo[key].value, (value) => {
        self.patientInfo[key].value = value;
      });
    },

    initEdit() {
      this.patientInfo = initPatientCfg();
      if (this.addOrEdit === "edit") {
        for (let id in this.patientInfo) {
          if (isDefined(this.patient[id])) {
            this.patientInfo[id].value = this.patient[id];
          }
        }
      }
    },
    checkPatientInput(obj) {
      let pat = {};
      let isspecial = false;
      let isempty = false;
      let key = "none";
      for (let id in obj) {
        let { value, required } = this.patientInfo[id] ? this.patientInfo[id] : {};
        isspecial = isDefined(value) && testSpecialChar(value);
        isempty = required && value === "";
        if (isspecial || isempty) {
          key = id;
          break;
        }
        pat[id] = isDefined(this.patientInfo[id]) ? this.patientInfo[id].value : obj[id];
      }
      return {
        isempty: isempty,
        isspecial: isspecial,
        patient: pat,
        key: key
      };
    },
    cancelTip(v) {
      this.invalidKey = this.invalidKey === v ? "none" : this.invalidKey;
    },
    add() {
      return this.checkPatientInput(this.patientInfo);
    },
    update() {
      // console.log('update前', this.patient)
      if (!isDefined(this.patient.lastname)) this.patient.lastname = "";
      return this.checkPatientInput(this.patient);
    },
    save() {
      let result = {};
      if (this.addOrEdit === "add") {
        result = this.add();
      } else {
        result = this.update();
      }
      let { isempty, isspecial, patient, key } = result;
      this.invalidKey = key;
      if (isempty) {
        this.notify(
          this.$t("langcfg.txtInputRequiredFileds"),
          this.$t("langcfg.txtError"),
          "error"
        );
      } else if (isspecial) {
        this.notify(
          `${this.$t("langcfg.txtSpecialCharacter")}: \r\n ${SPECIALKEYS}`,
          this.$t("langcfg.txtError"),
          "error",
          6000
        );
      } else {
        if (
          fileSys.isThirdPartyEnabled() &&
          this.addOrEdit === "add" &&
          typeof window.thirdpartyScript.addCustomer === "function"
        ) {
          window.thirdpartyScript.addCustomer(patient, (res) => {
            if (res.code === 200) {
              patient.customerId = res.body.customerId;
              this.$emit("save", patient);
              this.notify(res.message, this.$t("langcfg.txtPrompt"), "successs");
            } else {
              this.$emit("save", patient);
              this.notify(res.message, this.$t("langcfg.txtError"), "error");
            }
          });
        } else if (
          fileSys.isThirdPartyEnabled() &&
          this.addOrEdit === "edit" &&
          typeof window.thirdpartyScript.editCustomer === "function" &&
          patient.customerId
        ) {
          window.thirdpartyScript.editCustomer(patient, (res) => {
            if (res.code === 200) {
              this.$emit("save", patient);
              this.notify(res.message, this.$t("langcfg.txtPrompt"), "successs");
            } else {
              this.$emit("save", patient);
              this.notify(res.message, this.$t("langcfg.txtError"), "error");
            }
          });
        } else {
          this.$emit("save", patient);
        }
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  },

  computed: {
    tableWith() {
      return `${this.dispW}px`;
    },
    tableHeight() {
      return `${this.dispH}px`;
    },
    fnClass() {
      return this.invalidKey === "firstname" ? "invalid" : "";
    },
    pidClass() {
      return this.invalidKey === "pid" ? "invalid" : "";
    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  font-size: @header-fs + 10px;
}
.oprators {
  height: 100%;
  padding-left: @content-to-left;
  padding-bottom: 2px;
  .label {
    font-size: 35px;
  }
  .btn-oprator:hover {
    .label {
      color: @btn-hover-color;
    }
  }
  .btn-oprator {
    height: @header-fs+25px;
  }
  .el-button {
    width: 90%;
  }

  span {
    color: inherit;
  }
  z-index: 10;
}
.patient-info-cotainer {
  margin-top: 10px;
  background: @page-background;
}
.input-need {
  color: yellow;
}
.invalid {
  border: red solid 1px;
  border-bottom: red solid 1px;
  border-radius: 4px;
  box-sizing: border-box;
}
.gender-selector-containner {
  display: flex;
}
.gender-selector {
  width: 50%;
  text-align: center;
  font-size: @header-fs + 10px;
}
.el-radio {
  height: 60px;
  line-height: 60px;
  padding: 0 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
.el-radio /deep/ .el-radio__inner {
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.el-radio /deep/ .el-radio__label {
  font-size: 20px;
}
.el-radio-group {
  width: 100%;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/PatientEdit.vue